import { Navigate, Route, Routes, useNavigate } from "react-router-dom"
import { Help } from "./help"
import { Home } from "./home"
// import { InConstruction } from "./in-construction"
import { InConstructionArbitrios } from "./in-construction"
import { Payment } from "./Pagos"
// import { LoginPago } from "./Pagos"
import { NewProcedure } from "./new-procedure"
import { OpuProcedure } from "./opu-procedure"
import { DpuProcedure } from "./dpu-procedure"
import { QueryProcedure, QueryProcedureInner } from "./query-procedure"
import { Info } from "./urban-info"
import GoogleMaps from "./map"
import Tabla from "./components/UI/Tabla/Tabla"
import Logo from "./assets/Images/AlcaldiaLogo.jpg"
import Escudo from "./assets/Images/Escudo.jpg"
import Gestion from "./assets/Images/AlcaldiaPage.jpg"
import ProjectDetail from "./components/UI/Card/Detail"

type MenuItem = { label: string; link?: string; children?: MenuItem[] }

const menu: MenuItem[] = [
	{ label: "Inicio", link: "/" },
	{ label: "Consulta y pagos", link: "/query" },
	{
		label: "Planeamiento urbano",
		children: [
			{ label: "Efectuar trámite", link: "/urban/new" },
			{ label: "Consultar trámite", link: "/urban/query" },
			//{ label: 'Mapa POT',          link: '/urban/map' },
			{
				label: "Información de procesos y requisitos",
				children: [
					{ label: "Anteproyecto", link: "/urban/info/anteproyecto" },
					{ label: "Cambio de uso de suelo", link: "/urban/info/cambio-suelo" },
					{ label: "Certificado de uso de suelo", link: "/urban/info/certificado-suelo" },
					{ label: "Cierre y rotura de calles", link: "/urban/info/cierre-calle" },
					{ label: "Demolición", link: "/urban/info/demolicion" },
					{ label: "Estación de combustible", link: "/urban/info/combustible" },
					{ label: "Proyecto definitivo", link: "/urban/info/proyecto-definitivo" },
					{
						label: "Telecomunicaciónes",
						link: "/urban/info/telecomunicaciones",
					},
					{ label: "Remodelación o anexo", link: "/urban/info/remodelacion" },
					{ label: "Resellado de planos", link: "/urban/info/resellado-planos" },
					{ label: "Urbanización", link: "/urban/info/urbanizacion" },
					{ label: "Verjas", link: "/urban/info/verjas" },
				],
			},
		],
	},
	{ label: "Ayuda", link: "/help" },
]

export default function Main() {
	return (
		<Routes>
			<Route path="/urban/query-inner" element={<QueryProcedureInner />} />
			<Route
				path="*"
				element={
					<div className="min-h-screen flex flex-col">
						<div className="flex-1">
							<Header />
							<Navigation />
							<Content />
						</div>
						<Footer />
					</div>
				}
			/>
		</Routes>
	)
}

const Content = () => {
	return (
		<Routes>
			<Route path="/" element={<Home />} />
			<Route path="/query" element={<Payment />} />
			{/* <Route path="/pagos" element={<Payment />} /> */}
			<Route path="/arbitrios" element={<InConstructionArbitrios />} />
			<Route path="/urban/new" element={<NewProcedure />} />
			<Route path="/dpu/new" element={<DpuProcedure />} />
			<Route path="/opu/new" element={<OpuProcedure />} />
			<Route path="/urban/query" element={<QueryProcedure />} />
			<Route path="/opu/query" element={<QueryProcedure />} />
			<Route path="/urban/info/:id" element={<Info />} />
			<Route path="/help" element={<Help />} />
			<Route path="*" element={<Navigate to="/" />} />
			<Route path="/urban/map" element={<GoogleMaps />} />
			<Route path="/urban/Precios" element={<Tabla />} />
			<Route path="/urban/Detail/:id" element={<ProjectDetail />} />
		</Routes>
	)
}

const Header = () => {
	return (
		<header className="flex m-4 justify-between">
			<div className="flex gap-5">
				<img
					src={Logo}
					className="w-24"
					alt="Ayuntamiento Municipal de La Vega"
					onClick={() => {
						window.location.href = "/"
					}}
				/>

				<div className="mt-3">
					<h6 className="text-gray-400 font-normal">AYUNTAMIENTO MUNICIPAL</h6>
					<h1 className="font-extrabold text-5xl">LA VEGA</h1>
					<hr className="my-2" />
					<h6 className="text-gray-400 font-normal italic">
						Ciudad culta, olímpica y carnavalesca
					</h6>
				</div>
			</div>

			<div className="flex flex-col items-start m-4">
				<div className="flex items-center">
					<img src={Escudo} className="w-10" alt="Escudo dominicano" />
					<p className="italic ml-3">
						República <span className="font-bold">Dominicana</span>
					</p>
				</div>
				<div className="flex items-center">
					<img src={Gestion} className="gestion" alt="Gestión" />
				</div>
			</div>
		</header>
	)
}

const Navigation = () => {
	const navigate = useNavigate()

	return (
		<nav className="bg-red-500 flex">
			{menu.map((item) => (
				<div
					className={[
						"group py-3 px-6 relative",
						item.link ? "cursor-pointer" : "cursor-default",
					].join(" ")}
					onClick={() => (item.link ? navigate(item.link) : null)}
				>
					<div className="group-hover:-translate-y-0.5 transition-transform text-white font-semibold">
						{item.label}
					</div>
					{item.children ? (
						<div className="absolute hidden group-hover:block bg-white shadow-md min-w-full w-max cursor-default top-full border-l border-r border-gray-300 z-10">
							{item.children.map((item) => (
								<div
									onClick={() => (item.link ? navigate(item.link) : null)}
									className={[
										"relative py-2 px-3 hover:bg-red-500 hover:text-white text-red-500 font-medium sub-item",
										item.link ? "cursor-pointer" : "cursor-default",
									].join(" ")}
								>
									<div className="flex items-center gap-2">
										<div>{item.label}</div>
										{item.children ? ">" : undefined}
									</div>

									{item.children ? (
										<div className="absolute sub-item-sub-list bg-white left-full top-0 min-w-max border-l border-r border-gray-300 shadow-md border-t">
											{item.children.map((item) => (
												<div
													onClick={() => (item.link ? navigate(item.link) : undefined)}
													className="text-red-500 hover:text-white hover:bg-red-500 py-1 px-3 cursor-pointer"
												>
													{item.label}
												</div>
											))}
										</div>
									) : undefined}
								</div>
							))}
						</div>
					) : null}
				</div>
			))}
		</nav>
	)
}

const Footer = () => {
	return (
		<footer
			className="relative bg-[#040054] w-[100%] flex text-center flex-col py-4 footer"
			style={{
				borderTop: "4px solid #0071bc",
				borderRight: "none",
				borderBottom: "none",
				borderLeft: "none",
			}}
		>
			<div className="flex space-x-6 justify-center items-center">
				<a href="https://presidencia.gob.do">
					<img src={Escudo} alt="Escudo Nacional" />
				</a>
				<a href="https://ayuntamientolavega.gob.do/">
					<img className="w-14" src={Logo} alt="Escudo La Vega" />
				</a>
			</div>
			<p className="text-white">Ayuntamiento Municipal de La Vega</p>
			<p className="text-white">
				C/ Don Antonio Guzmán # 419, Frente al Parque Duarte, Concepción de La Vega, La Vega,
				R.D.
			</p>
			<p className="text-white">
				<a href="tel:182982422000">Tel.: (809) 242-2000</a>
			</p>
			<p className="text-white">
				<a href="mailto:alcaldiadelavega@gmail.com">alcaldiadelavega@gmail.com</a>
				<br></br>
				<a href="mailto:planeamientourbanolv@gmail.com" className="hover:underline">
					planeamientourbanolv@gmail.com
				</a>
			</p>
			<caption className="text-xs text-white">@2023 Todos los Derechos Reservados</caption>
		</footer>
	)
}
